import React from 'react';

import Select from '../commons/Select.jsx'
import Helper from "../../../model/Helper";
import SidebarFrame from "./SidebarFrame";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class SchubladenSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Schublade");
    }

    state = {
        nutzhoehe: this.nutzhoehe(this.schublade.faecherHoehe),
        products: APP.findProductsByType('Schubladenbox')
    }

    get schublade() {
        return this.props.model.vsData;
    }

    getSidebarParent() {
        return "einbauten";
    }

    faecherChanged(faecherAnzahl,faecherHoehe) {
        const calc = this.schublade.calcFaecherHoehe(faecherAnzahl, faecherHoehe);
        if (calc?.anzahl != faecherAnzahl) {
            this.setState({
                message: I18N("Ungültige Höhe.")
            });
        } else {
            this.setState({
                message: Math.abs(calc.hoehe - this.schublade.faecherHoehe) > 0.1 ? I18N('dialogSchubladenboxKorrigiert', Helper.round(calc.hoehe)) /*'Die Fachhöhe wurde auf ' + hoehe + ' korrgiert.'*/ : '',
                nutzhoehe: this.nutzhoehe(calc.hoehe)
            });
            APP.model.tryCompile(() => this.schublade.setFaecher(calc.anzahl, calc.hoehe));
        }
    }

    nutzhoehe(hoehe) {
        return Helper.round(hoehe - this.schublade.schrank.options.getFloat('schublade_nutzhoehe_offset'))
    }


    renderBody() {
        if (this.schublade.element==null) {
            return;
        }
        // console.log("SCHUBLADE RENDER", this.props)
        const arrangement = APP.arrangement;
        const maxFaecher = Math.floor(this.schublade.maxFaecher)
        const options = [...Array(maxFaecher).keys()].map(value => ({value: value + 1, label: value + 1}));
        const types = this.state.products.map(product => ({
            value: product.Artikelnummer,
            label: product.Anzeigename,
        }));

        const hasDekorwahl = this.schublade.hasFronts || this.schublade.schrank.options.getBool('SchubladeInnenliegend_mit_dekorwahl',false);

        return (
            <div className="appear">
                {/* <fieldset>
                    <legend>{I18N("Maße")}</legend>
                    <table>
                        <tbody>
                        <tr>
                            <td>{I18N("Breite")}:</td>
                            <td>{Helper.formatToRulerUnit(this.schublade.size.x)}</td>
                        </tr>
                        <tr>
                            <td>{I18N("Tiefe")}:</td>
                            <td>{Helper.formatToRulerUnit(this.schublade.size.z)}</td>
                        </tr>
                        <tr>
                            <td>{I18N("Nutzhöhe")}:</td>
                            <td>{Helper.formatToRulerUnit(this.state.nutzhoehe)}</td>
                        </tr>
                        <tr>
                            <td colSpan="2">{this.state.message}</td>
                        </tr>
                        </tbody>
                    </table>
                </fieldset> */}

                <Select value={this.schublade.faecherAnzahl} options={options}
                        onChange={value => this.faecherChanged(value, this.schublade.faecherHoehe)} label={I18N("Anzahl Fächer")}/>

                {this.schublade.schrank.options.getMaxValue('schublade_hoehe')-this.schublade.schrank.options.getMinValue('schublade_hoehe')>0.1 && (
                    <MeasureNumberInput value={this.schublade.faecherHoehe} onCommit={value => this.faecherChanged(this.schublade.faecherAnzahl, value)}
                                 label={I18N("dialogSchubladenboxHeight")}/>
                )}

                {/*{hasDekorwahl && (<DekorInput value={APP.getMaterialForVsData(this.schublade)} appear={true}*/}
                                              {/*dekore={APP.getMaterialsForVsData(this.schublade)}*/}
                                              {/*setValue={value=>APP.setMaterialForVsData(this.schublade,value)}*/}
                                              {/*label={I18N("Welches Dekor wünschen Sie?")}/>)}*/}


                {/*{this.schublade.hasFronts && (*/}
                    {/*<GriffInput value={APP.arrangement.griffArtikelnummer}*/}
                                {/*setValue={APP.model.tryWrap(this, value => APP.arrangement.griffArtikelnummer = value)}*/}
                                {/*label={I18N("Welche Griffe wünschen Sie?")}/>*/}
                {/*)}*/}

            </div>
        )
    }
}